import { render, staticRenderFns } from "./GrowTrade.vue?vue&type=template&id=fab4da00&scoped=true&"
import script from "./GrowTrade.vue?vue&type=script&lang=js&"
export * from "./GrowTrade.vue?vue&type=script&lang=js&"
import style0 from "./GrowTrade.vue?vue&type=style&index=0&id=fab4da00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab4da00",
  null
  
)

export default component.exports